import Vue from 'vue'
import router from '@/router'
import store from '@/store'
import moment from "moment";
import httpUtil from "@/utils/httpUtil";

/**
 * 获取uuid
 */
export function getUUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    return (c === 'x' ? (Math.random() * 16 | 0) : ('r&0x3' | '0x8')).toString(16)
  })
}

/**
 * 是否有权限
 * @param {*} key
 */
export function isAuth(key) {
  return JSON.parse(sessionStorage.getItem('permissions') || '[]').indexOf(key) !== -1 || false
}

/**
 * 树形数据转换
 * @param {*} data
 * @param {*} id
 * @param {*} pid
 */
export function treeDataTranslate(data, id = 'id', pid = 'parentId') {
  var res = []
  var temp = {}
  for (var i = 0; i < data.length; i++) {
    temp[data[i][id]] = data[i]
  }
  for (var k = 0; k < data.length; k++) {
    if (temp[data[k][pid]] && data[k][id] !== data[k][pid]) {
      if (!temp[data[k][pid]]['children']) {
        temp[data[k][pid]]['children'] = []
      }
      if (!temp[data[k][pid]]['_level']) {
        temp[data[k][pid]]['_level'] = 1
      }
      data[k]['_level'] = temp[data[k][pid]]._level + 1
      temp[data[k][pid]]['children'].push(data[k])
    } else {
      res.push(data[k])
    }
  }
  return res
}

/**
 * 清除登录信息
 */
export function clearLoginInfo() {
  Vue.cookie.delete('zf-token')
  store.commit('resetStore')
  router.options.isAddDynamicMenuRoutes = false
}

/**
 * 格式化日期时间
 * @returns {string}
 * @param row
 * @param column
 */
export function formatDatetime(row, column) {
  let date = row[column.property];
  if (date === undefined || date === null) {
    return "";
  }
  return moment(date).format('YYYY-MM-DD HH:mm:ss')
}

export function formatDate(row, column) {
  let date = row[column.property];
  if (date === undefined || date === null) {
    return "";
  }
  return moment(date).format('YYYY-MM-DD')
}

export function formatDateStr(date) {
  if (date === undefined || date === null) {
    return "";
  }
  return moment(date).format('YYYY-MM-DD')
}

export function fenToYuanFormat(_, __, price) {
  return fenToYuan(price)
}

export function fenToYuan(price) {
  if (typeof price === 'undefined') return '0.00'
  const parsedNumber = typeof price === 'string' ? parseFloat(price) : price
  return (parsedNumber / 100.0).toFixed(2)
}

export function yuanToFen(amount) {
  if (typeof amount === 'undefined') return 0
  const parsedNumber = typeof amount === 'string' ? parseFloat(amount) : amount
  return Math.round(parsedNumber * 100)
}

/**
 * 工作小时转工作日
 * @param hour
 * @returns {number}
 */
export function hourToDay(hour) {
  if (typeof hour === 'undefined') return 0
  const day = typeof hour === 'string' ? parseInt(hour)  : hour
  return (day / 8)
}

/**
 * 工作小时转工作日 表格翻译用
 * @param row
 * @param col
 * @returns {number}
 */
export function hourToDayForTable(row,col) {
  return hourToDay(row[col.property])
}

/**
 * 字典格式化
 * @param row 不是表格调用时此项为 字典类型
 * @param col 不是表格调用时此项为 字典值
 * @returns {string}
 */
export function formatDict(row, col) {
  let name = "";
  const dictKey = col.property;
  const dictValue = row[col.property];
  if (this.$store.state.dictionary.dict[dictKey] === undefined) {
    this.$http({
      url: this.$http.adornUrl('/sys/dictionary/getDicts'),
      method: 'post',
      data: this.$http.adornData([dictKey], false)
    }).then(({data}) => {
      if (data && data.code === 0) {
        this.$store.state.dictionary.dict[dictKey] = data.select[dictKey]
      }
    })
  }
  this.$store.state.dictionary.dict[dictKey].forEach((item) => {
    if (dictValue === item.value) {
      name = item.label
    }
  })
  return name
}

export async function getDictData(dictType, value) {
  let dictList = store.state.dictionary.dict[dictType]
  if (dictList === undefined || dictList.length === 0) {
    dictList = await httpUtil.get('/sys/dictionary/getDictByType', {'type': dictType});
  }
  if (dictList === undefined || dictList.length === 0) {
    return '';
  }
  value = value + ''
  // 强制转换成字符串，因为 DictData 小类数值，是字符串
  for (const dictData of dictList) {
    if (dictData.value === value) {
      return dictData;
    }
  }
  return undefined
}

/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}
/**
 * 判断是否是图片文件
 * @param {string} path
 * @returns {boolean}
 */
export function isImage(path) {
  return /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(path);
}
/**
 * 判断文件类型
 * @param {string} path
 * @returns {"image"|"pdf"|"other"}
 */
export function getFileType(path) {
  if (!path) return "other";

  const lowerPath = path.toLowerCase();

  if (/\.(jpg|jpeg|png|gif|bmp|webp)$/.test(lowerPath)) {
    return "image";
  } else if (/\.pdf$/.test(lowerPath)) {
    return "pdf";
  } else {
    return "other";
  }
}

/**
 * 根据项目ID获取项目名称
 * @param {string|number} projectId 项目id
 * @returns {Promise<string>} 返回项目名称，找不到返回空字符串
 */
export async function getProjectNameById(projectId) {
  if (!projectId) {
    return ''
  }
  try {
    const res = await httpUtil.get(`/work/project/info/${projectId}`)
    console.log('getProjectNameById res:', res)
      return res.projectName || ''
  } catch (e) {
    console.error('获取项目名称异常：', e)
    return ''
  }
}





// WEBPACK FOOTER //
// ./src/utils/index.js